import { TIMESHEET_ENTRY_TYPES } from '../constants';

export default function getTotalBreakMinutes(timesheets) {
  if (!timesheets || !timesheets.length) {
    return 0;
  }

  let prev;
  return timesheets.reduce((acc, entry) => {
    let add = 0;
    if (
      prev &&
      prev.type === TIMESHEET_ENTRY_TYPES.BREAK_START &&
      entry.type === TIMESHEET_ENTRY_TYPES.BREAK_END
    ) {
      add = (entry.timestamp - prev.timestamp) / 1000 / 60;
    }

    prev = entry;
    return acc + add;
  }, 0);
}
